import classnames from "classnames";
import React from "react";

// tslint:disable-next-line:no-var-requires
const style = require("./ActiveFilterButton.scss");

export interface ActiveFilterButtonProps {
    text: string;
    active: boolean;
    filterTimespan: number;
    onClick: (filterTimespan: number) => void;
}

export default function ActiveFilterButton(props: ActiveFilterButtonProps) {
    const handleClick = () => {
        props.onClick(props.filterTimespan);
    };

    const classes = classnames(style.button, { [style.active]: props.active });
    return (
        <span className={classes} onClick={handleClick}>
            <span>{props.text}</span>
        </span>
    );
}
